export default __webpack_public_path__ + "static/media/export-icon.839a53c5.svg";